import { MagicTableCellLink } from '@sequencehq/core-components'

export const CreditNoteLinkCell = ({
  creditNote
}: {
  creditNote: { id: string; name: string } | null | undefined
}) => {
  if (!creditNote) {
    return null
  }

  return (
    <MagicTableCellLink
      to={`/credit-notes/${creditNote.id}`}
      label={creditNote.name}
    />
  )
}
